<template>
    <div class="container">
        <div class="container-main">
            <div class="nav-bar">
                <a href="javascript:void(0)" class="icon" @click="goBackHandle">
                    <van-icon name="arrow-left" />
                </a>
                <h3 class="title">{{ $t('woka.activityPage') }}</h3>
            </div>
            <div class="content">
                <div class="content-header">
                    <h2 class="title">{{ $t('woka.unlockDish') }}</h2>
                    <p class="text">{{ $t('woka.unlockText') }}</p>
                </div>
                <div class="content-body">
                    <div class="rule">
                        <span class="rule-line"></span>
                        <p class="rule-text">{{ $t('woka.activityRule') }}</p>
                        <span class="rule-line"></span>
                    </div>
                    <div class="explain">
                        <p class="explain-text">{{ $t('woka.ruleText') }}</p>
                        <div class="explain-picture">
                            <img src="../assets/images/woka_act_more.png" alt="">
                        </div>
                    </div>
                    <ul class="list">
                        <li class="item">
                            <div class="item-header">
                                <div class="header-core">
                                    <div class="icon">
                                        <img src="../assets/images/we_chat.png" class="icon" alt="">
                                    </div>
                                    <p class="text">{{ $t('woka.weChat') }}</p>
                                </div>
                            </div>
                            <div class="item-body">
                                <p class="text">{{ $t('woka.wechatText') }}</p>
                            </div>
                        </li>
                        <li class="item">
                            <div class="item-header">
                                <div class="header-core">
                                    <div class="icon">
                                        <img src="../assets/images/tik_tok.png" class="icon" alt="">
                                    </div>
                                    <p class="text">抖音</p>
                                </div>
                            </div>
                            <div class="item-body">
                                <p class="text">{{ $t('woka.issueWork') }}</p>
                                <p class="text">{{ $t('woka.douyinText1') }}</p>
                                <p class="text">{{ $t('woka.douyinText2') }}</p>
                                <p class="text">{{ $t('woka.douyinText3') }}</p>
                            </div>
                        </li>
                        <li class="item">
                            <div class="item-header">
                                <div class="header-core">
                                    <div class="icon">
                                        <img src="../assets/images/xiao_red_book.png" class="icon" alt="">
                                    </div>
                                    <p class="text">{{ $t('woka.redBook') }}</p>
                                </div>
                            </div>
                            <div class="item-body">
                                <p class="text">{{ $t('woka.issueWork') }}</p>
                                <p class="text">{{ $t('woka.douyinText1') }}</p>
                                <p class="text">{{ $t('woka.redBookText2') }}</p>
                            </div>
                        </li>
                        <li class="item">
                            <div class="item-header">
                                <div class="header-core">
                                    <div class="icon">
                                        <img src="../assets/images/instagram.png" class="icon" alt="">
                                    </div>
                                    <p class="text">Instagram</p>
                                </div>
                            </div>
                            <div class="item-body">
                                <p class="text">{{ $t('woka.instagramText1') }}</p>
                                <p class="text">{{ $t('woka.instagramText2') }}</p>
                            </div>
                        </li>
                        <li class="item">
                            <div class="item-header">
                                <div class="header-core">
                                    <div class="icon">
                                        <img src="../assets/images/facebook.png" class="icon" alt="">
                                    </div>
                                    <p class="text">Facebook</p>
                                </div>
                            </div>
                            <div class="item-body">
                                <p class="text">{{ $t('woka.instagramText1') }}</p>
                                <p class="text">{{ $t('woka.instagramText2') }}</p>
                            </div>
                        </li>
                        <li class="item">
                            <div class="item-header">
                                <div class="header-core">
                                    <div class="icon">
                                        <img src="../assets/images/tik_tok.png" class="icon" alt="">
                                    </div>
                                    <p class="text">TikTok</p>
                                </div>
                            </div>
                            <div class="item-body">
                                <p class="text">{{ $t('woka.tikTokText1') }}</p>
                                <p class="text">{{ $t('woka.tikTokText2') }}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="handle">
                <a class="btn" href="javascript:void(0);" @click="shareHandle">
                    <img src="../assets/images/share.png" alt="">
                    {{ $t('woka.partActivity') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WokaActivity",
    // 组件
    components: {},
    props: {},
    data () {
        return {
            deviceType: '',   // 设备类型 ios / android
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 获取设备类型
        getDeviceType () {
            // 判断手机系统
            let userAgent = navigator.userAgent
            if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
                this.deviceType = 'ios'
            } else if (userAgent.includes('Android')) {
                this.deviceType = 'android'
            }
        },
        // 返回
        goBackHandle () {
            if (this.deviceType === 'ios') {
                // window.webkit.messageHandlers.Native.backAction();
                window.webkit.messageHandlers.Native.postMessage({ "type": "back" });
            } else if (this.deviceType === 'android') {
                android_invoke.popup();
            }
        },
        // 分享
        shareHandle () {
            if (this.deviceType === 'ios') {
                // window.webkit.messageHandlers.Native.joinActivityAction();
                window.webkit.messageHandlers.Native.postMessage({ "type": "join" });
            } else if (this.deviceType === 'android') {
                android_invoke.join();
            }
        },
    },
    // 创建完成
    created () {
        // 获取设备类型
        this.getDeviceType()
    },
    // 挂载完成
    mounted () {

    },
    // 销毁之前
    beforeDestroy () {
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    background-color: #000000;

    .container-main {
        background-image: url("../assets/images/woka_act_bg.png");
        background-repeat: no-repeat;
        background-size: 100% auto;

        .nav-bar {
            width: 100%;
            height: 48px;
            position: relative;

            .icon {
                position: absolute;
                left: 12px;
                top: 12px;
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #FFFFFF;
                font-size: 18px;
            }

            .title {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                font-size: 18px;
                color: #FFFFFF;
            }
        }

        .content {
            .content-header {
                margin-top: 40px;
                padding-left: 56px;
                padding-right: 56px;

                .title {
                    width: 100%;
                    font-weight: 600;
                    font-size: 36px;
                    color: #FFFFFF;
                    line-height: 44px;
                }

                .text {
                    margin-top: 12px;
                    font-weight: 600;
                    font-size: 14px;
                    color: #FFFFFF;
                    line-height: 22px;
                }
            }

            .content-body {
                margin-top: 30px;

                .rule {
                    height: 28px;
                    padding-left: 48px;
                    padding-right: 48px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .rule-text {
                        flex-shrink: 0;
                        padding-left: 12px;
                        padding-right: 12px;
                        font-weight: 600;
                        font-size: 20px;
                        color: #FFFFFF;
                    }

                    .rule-line {
                        flex-grow: 1;
                        height: 1px;
                        background-color: rgba(255, 255, 255, .8);
                    }
                }

                .explain {
                    margin-top: 12px;
                    width: 100%;
                    padding-left: 32px;
                    padding-right: 32px;
                    display: flex;
                    align-items: center;

                    .explain-text {
                        flex-grow: 1;
                        padding-right: 12px;
                        font-weight: 600;
                        font-size: 14px;
                        color: #FFFFFF;
                        line-height: 22px;
                    }

                    .explain-picture {
                        width: 136px;
                        height: 117px;
                        flex-shrink: 0;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }

                .list {
                    padding-left: 32px;
                    padding-right: 32px;

                    .item {
                        margin-top: 12px;

                        .item-header {
                            background-image: url("../assets/images/woka_app_bg.png");
                            background-repeat: no-repeat;
                            background-size: 100% auto;

                            .header-core {
                                height: 32px;
                                padding-left: 4px;
                                padding-right: 4px;
                                display: flex;
                                align-items: center;

                                .icon {
                                    width: 32px;
                                    height: 32px;

                                    img {
                                        width: 100%;
                                        height: 100%;
                                        object-fit: contain;
                                    }
                                }

                                .text {
                                    font-family: PingFang SC, PingFang SC;
                                    font-weight: 600;
                                    font-size: 14px;
                                    color: rgba(0, 0, 0, 0.9);
                                }
                            }

                        }

                        .item-body {
                            width: 100%;
                            padding: 12px 20px;
                            background: #FFFDF1;
                            border-radius: 0 0 6px 6px;

                            .text {
                                font-weight: 600;
                                font-size: 14px;
                                color: rgba(0, 0, 0, 0.9);
                                line-height: 22px;
                            }
                        }
                    }
                }
            }
        }

        .handle {
            padding: 24px 32px 58px;

            .btn {
                width: 100%;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #5500FF;
                border-radius: 6px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                font-size: 16px;
                color: #FFFFFF;

                img {
                    width: 20px;
                    height: 20px;
                    object-fit: contain;
                    margin-right: 4px;
                }
            }
        }
    }
}
</style>
